import { Injectable, signal } from '@angular/core';
import { Lagerstamm } from '../models/lagerstamm';

@Injectable()
export class SelectedLagerService {
  readonly lager = signal<Lagerstamm | null>(null);
}
